import { useState, useEffect } from 'react';
export function useDetectPlatform() {
  const [platform, setPlatform] = useState<'ios' | 'android' | 'unknown'>('unknown');
  useEffect(() => {
    const userAgent = navigator.userAgent;
    if (/android/i.test(userAgent)) {
      setPlatform('android');
    } else if (/iPad|iPhone|iPod|Safari/.test(userAgent) && !window.MSStream) {
      setPlatform('ios');
    } else {
      setPlatform('unknown');
    }
  }, []);
  return platform;
}